import { MenuCategory, MenuItem } from '../services/ordersApi';

/** Временно: демо-меню для проверки дизайна. Выключить — false. */
export const MENU_MOCK_MODE = false;

export const mockMenuCategories: MenuCategory[] = [
  {
    id: 'starters',
    name: 'Закуски',
    items: [
      {
        id: 'mock-edamame',
        name: 'Эдамаме с морской солью',
        description: 'Бобы сои, хлопья соли, кунжутное масло',
        price: 390,
        isUnavailable: false,
        nutrition: { energy: 180, proteins: 14, fats: 8, carbs: 12 },
      },
      {
        id: 'mock-tuna',
        name: 'Тартар из тунца',
        description: 'Тунец, авокадо, соус понзу, кунжут, чипсы нори',
        price: 790,
        isUnavailable: false,
        nutrition: { energy: 320, proteins: 28, fats: 18, carbs: 8 },
      },
      {
        id: 'mock-burrata',
        name: 'Буррата с томатами',
        description: 'Сливочная буррата, черри, базилик, оливковое масло',
        price: 690,
        isUnavailable: false,
      },
      {
        id: 'mock-wings',
        name: 'Крылья в соусе гочуджан',
        description: 'Хрустящие крылья, корейский соус, кунжут',
        price: 590,
        isUnavailable: true,
      },
    ],
  },
  {
    id: 'soups',
    name: 'Супы',
    items: [
      {
        id: 'mock-miso',
        name: 'Мисо суп',
        description: 'Паста мисо, тофу, водоросли, зелёный лук',
        price: 350,
        isUnavailable: false,
      },
      {
        id: 'mock-tom-yum',
        name: 'Том ям с креветками',
        description: 'Кокосовое молоко, лемонграсс, галангал, креветки',
        price: 650,
        isUnavailable: false,
        nutrition: { energy: 280, proteins: 18, fats: 14, carbs: 16 },
      },
      {
        id: 'mock-pho',
        name: 'Фо бо',
        description: 'Говяжий бульон, рисовая лапша, ростбиф, зелень',
        price: 620,
        isUnavailable: false,
      },
    ],
  },
  {
    id: 'mains',
    name: 'Горячее',
    items: [
      {
        id: 'mock-salmon',
        name: 'Лосось на гриле',
        description: 'Филе лосося, соус терияки, овощи вок, рис',
        price: 1290,
        isUnavailable: false,
        nutrition: { energy: 540, proteins: 42, fats: 28, carbs: 32 },
      },
      {
        id: 'mock-steak',
        name: 'Стейк рибай',
        description: 'Мраморная говядина, перечный соус, картофель гриль',
        price: 1890,
        isUnavailable: false,
      },
      {
        id: 'mock-duck',
        name: 'Утка по-пекински',
        description: 'Хрустящая утка, блинчики, соус хойсин, огурец',
        price: 1490,
        isUnavailable: false,
      },
      {
        id: 'mock-pad-thai',
        name: 'Пад тай с креветками',
        description: 'Рисовая лапша, креветки, арахис, лайм, ростки',
        price: 890,
        isUnavailable: false,
      },
      {
        id: 'mock-risotto',
        name: 'Ризотто с грибами',
        description: 'Арборио, белые грибы, пармезан, трюфельное масло',
        price: 780,
        isUnavailable: false,
      },
    ],
  },
  {
    id: 'pizza',
    name: 'Пицца',
    items: [
      {
        id: 'mock-margherita',
        name: 'Маргарита',
        description: 'Томаты сан-марцано, моцарелла, базилик',
        price: 690,
        isUnavailable: false,
      },
      {
        id: 'mock-pepperoni',
        name: 'Пепперони',
        description: 'Пикантная колбаса, моцарелла, томатный соус',
        price: 790,
        isUnavailable: false,
      },
      {
        id: 'mock-truffle',
        name: 'Трюфель и грибы',
        description: 'Крем, грибы, трюфельное масло, руккола',
        price: 990,
        isUnavailable: false,
      },
      {
        id: 'mock-diavola',
        name: 'Дьявола',
        description: 'Острая салями, халапеньо, моцарелла',
        price: 850,
        isUnavailable: false,
      },
    ],
  },
  {
    id: 'bowls',
    name: 'Боулы',
    items: [
      {
        id: 'mock-poke',
        name: 'Поке с лососем',
        description: 'Рис, лосось, авокадо, эдамаме, соус спайси майо',
        price: 790,
        isUnavailable: false,
      },
      {
        id: 'mock-chicken-bowl',
        name: 'Боул с курицей терияки',
        description: 'Рис, курица, овощи, кунжут, соус терияки',
        price: 690,
        isUnavailable: false,
      },
      {
        id: 'mock-veg-bowl',
        name: 'Овощной боул',
        description: 'Киноа, батат, хумус, зелень, семечки',
        price: 620,
        isUnavailable: false,
      },
    ],
  },
  {
    id: 'desserts',
    name: 'Десерты',
    items: [
      {
        id: 'mock-mochi',
        name: 'Моти ассорти',
        description: 'Три вкуса сезонного моти',
        price: 420,
        isUnavailable: false,
      },
      {
        id: 'mock-cheesecake',
        name: 'Чизкейк Нью-Йорк',
        description: 'Классический, ягодный кулис',
        price: 490,
        isUnavailable: false,
      },
      {
        id: 'mock-matcha',
        name: 'Тирамису матча',
        description: 'Сыр маскарпоне, печенье, чай матча',
        price: 520,
        isUnavailable: false,
      },
    ],
  },
  {
    id: 'drinks',
    name: 'Напитки',
    items: [
      {
        id: 'mock-espresso',
        name: 'Эспрессо',
        description: 'Двойной шот',
        price: 180,
        isUnavailable: false,
      },
      {
        id: 'mock-flat-white',
        name: 'Флэт уайт',
        description: 'Эспрессо, молоко',
        price: 280,
        isUnavailable: false,
      },
      {
        id: 'mock-matcha-latte',
        name: 'Матча латте',
        description: 'Японский чай матча, молоко',
        price: 350,
        isUnavailable: false,
      },
      {
        id: 'mock-lemonade',
        name: 'Лимонад юдзу',
        description: 'Домашний, с мятой',
        price: 320,
        isUnavailable: false,
      },
      {
        id: 'mock-wine-glass',
        name: 'Вино бокал дня',
        description: 'Спросите у бармена',
        price: 450,
        isUnavailable: false,
      },
    ],
  },
  {
    id: 'bar',
    name: 'Бар',
    items: [
      {
        id: 'mock-negroni',
        name: 'Негрони',
        description: 'Джин, кампари, сладкий вермут',
        price: 590,
        isUnavailable: false,
      },
      {
        id: 'mock-whiskey-sour',
        name: 'Виски сауэр',
        description: 'Бурбон, лимон, сахар, белок',
        price: 620,
        isUnavailable: false,
      },
      {
        id: 'mock-highball',
        name: 'Хайсболл',
        description: 'Виски, содовая, цедра',
        price: 480,
        isUnavailable: false,
      },
      {
        id: 'mock-mocktail',
        name: 'Безалкогольный спритц',
        description: 'Тоник, цитрус, ягоды',
        price: 390,
        isUnavailable: false,
      },
    ],
  },
];

export function findMockMenuItem(id: string): MenuItem | null {
  for (const cat of mockMenuCategories) {
    const item = cat.items.find((i) => i.id === id);
    if (item) return item;
  }
  return null;
}
